module.exports = ".div1 {\n  width: 222px;\n  height: 111px;\n  background-color: red; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/reporte-resumen-oyv/reporte-resumen-oyv.component.scss
// module id = ./src/app/components/reporte-resumen-oyv/reporte-resumen-oyv.component.scss
// module chunks = main